import React from 'react';
import styled from 'styled-components';
import EditIcon from '@mui/icons-material/Edit';
import { ButtonProps } from '@mui/material/Button';
import { mixinCircle } from '~/assets/styles/mixin';

const StyledButton = styled.button`
  ${mixinCircle}
  transition: opacity 0.4s;
  color: #a2b2be;
  &:hover {
    opacity: 0.7;
  }
`;

type Props = {
  handleClick: ButtonProps['onClick'];
  name: string;
};

const EditButton: React.FC<Props & ButtonProps> = ({ handleClick, name }): JSX.Element => (
  <StyledButton data-testid={`uiParts-EditButton-btn-${name}`} onClick={handleClick} name={name}>
    <EditIcon data-testid={`uiParts-EditButton-icn-${name}`} />
  </StyledButton>
);

export default EditButton;
